import React from 'react';
import { Link } from 'react-router-dom';

const CompanyHelpCenter: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Help Center</h6>
                        <p className="text-secondary small">Let customers, users find support & connect</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/company-profile"> Company</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Help Center</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="py-4 py-lg-5 px-3 position-relative text-center rounded overflow-hidden mb-3 mb-lg-4 z-index-0 bg-theme-r-gradient">
                    <figure className="coverimg h-100 w-100 z-index-0 position-absolute top-0 start-0 m-0 opacity-25">
                        <img src={asset("../../assets/img/background-image/backgorund-image-2.jpg")} alt="" className="d-none" />
                    </figure>
                    <div className="card-body px-lg-4">
                        <div className="row gx-3 gx-lg-4 mb-3 mb-lg-4 align-items-center justify-content-center vh-50 position-relative">
                            <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6 text-center">
                                <h1>How can we Help you?</h1>
                                <p className="opacity-75 mb-3">Find solution for your troubles. We have wide range of learning tutorials and supports.</p>
                                {/* search */}
                                <div className="input-group card flex-row">
                                    <span className="input-group-text"><i className="bi bi-search"></i></span>
                                    <input className="form-control form-control-lg" type="search" placeholder="Search here..." />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* quick connect links */}
                <div className="row gx-3 gx-lg-4 justify-content-center">
                    <div className="col-12 col-md-4">
                        <div className="card text-center mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-person-video3 fs-2 text-theme-1 mb-3 d-block"></i>
                                <h5 className="mb-1">Schedule a Demo</h5>
                                <p className="text-secondary">Get details of features and quick look on how it works. Schedule a demo now.</p>
                                <button className="btn btn-link">Book Demo</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="card text-center mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-chat-right-dots fs-2 text-theme-1 mb-3 d-block"></i>
                                <h5 className="mb-1">Communicate</h5>
                                <p className="text-secondary">You have live assistant with whom you can share your concern & get answered quickly.</p>
                                <button className="btn btn-link">Book Demo</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="card text-center mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-life-preserver fs-2 text-theme-1 mb-3 d-block"></i>
                                <h5 className="mb-1">Get Support</h5>
                                <p className="text-secondary">Connect with our expert by submitting details with photos and documents.</p>
                                <button className="btn btn-link">Raise Ticket</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* popular questions*/}
                <h5 className="mb-3 mb-lg-4">Popular Questions</h5>
                <p className="mb-3 mb-lg-4">
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">How we can do edits in index pages?</a>
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Is this template comes with Laravel vue js?</a>
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Is there angular development suggestions before starting work?</a>
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">How to reduce width of any boxes with responsiveness?</a>
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">How can you defined new color set ?</a>
                    <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">What are the primary color set and what to keep in mind?</a>
                </p>

                {/* questions by categories*/}
                <h5 className="mb-3 mb-lg-4">Help by Categories</h5>
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                                    <div className="col">
                                        <h6>Login and Logout flow</h6>
                                    </div>
                                </div>
                                <div className="list-group list-group-flush border-0 bg-none">
                                    <a className="list-group-item list-group-item-action">Login purpose </a>
                                    <a className="list-group-item list-group-item-action">What are the Login options?</a>
                                    <a className="list-group-item list-group-item-action">How to reset password?</a>
                                    <a className="list-group-item list-group-item-action">How to change password?</a>
                                    <a className="list-group-item list-group-item-action">Where from I can logout from?</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                                    <div className="col">
                                        <h6>Customization & Settings</h6>
                                    </div>
                                </div>
                                <div className="list-group list-group-flush border-0 bg-none">
                                    <a className="list-group-item list-group-item-action">How to change color scheme? </a>
                                    <a className="list-group-item list-group-item-action">Personalize background images?</a>
                                    <a className="list-group-item list-group-item-action">Update colors in theme colors?</a>
                                    <a className="list-group-item list-group-item-action">How to create new theme colors set?</a>
                                    <a className="list-group-item list-group-item-action">Purpose of the crowd assets?</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                                    <div className="col">
                                        <h6>License and Usage</h6>
                                    </div>
                                </div>

                                <div className="list-group list-group-flush border-0 bg-none">
                                    <a className="list-group-item list-group-item-action">What is mean bt free license?</a>
                                    <a className="list-group-item list-group-item-action">What is business license?</a>
                                    <a className="list-group-item list-group-item-action">How is PRO different from free license?</a>
                                    <a className="list-group-item list-group-item-action">Benefits of PRO license?</a>
                                    <a className="list-group-item list-group-item-action">Personal use limitation and restrictions?</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-4 py-lg-5 px-3 position-relative text-center rounded overflow-hidden mb-3 mb-lg-4 z-index-0 bg-theme-r-gradient">
                    <figure className="coverimg h-100 w-100 z-index-0 position-absolute top-0 start-0 m-0 opacity-25">
                        <img src={asset("../../assets/img/background-image/backgorund-image-2.jpg")} alt="" />
                    </figure>
                    <div className="row gx-3 justify-content-center z-index-1 position-relative">
                        <div className="col-12 col-md-8 col-lg-6">
                            <h4>Couldn't find what you are looking for?</h4>
                            <p className="opacity-75 small mb-3 mb-lg-4">Its possible human made mistakes and possibly we may missed it. We are happy to assist you as well as upgrade our system. Do let us know your query, concern and feedback.</p>
                            <a className="btn btn-theme">Connect</a>
                            <a className="btn btn-link text-white ms-2">Leave feedback</a>
                        </div>
                    </div>
                </div>
                {/* recent news */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="row gx-0">
                                <div className="col-12 col-md-6">
                                    <div className="h-100 w-100 miheight-200 coverimg">
                                        <img src={asset("../../assets/img/adminuiux/image-2.jpg")} className="mw-100" alt="" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="card-body">
                                        <p className="mb-3">
                                            <span className="badge badge-lg badge-light text-bg-theme-1 theme-green">Course</span>
                                        </p>
                                        <h6>Getting job seriously may helps you to become the best entrepreneur in the world.</h6>
                                        <p className="text-secondary small mb-3">When you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                        <div className="row gx-3 mb-3">
                                            <div className="col-auto align-self-center">
                                                <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                                    <img src={asset("../../assets/img/adminuiux/user-4.jpg")} alt="" />
                                                </figure>
                                            </div>
                                            <div className="col align-self-center">
                                                <h6 className="mb-0">David Warner</h6>
                                                <p className="small text-secondary">London, UK</p>
                                            </div>
                                        </div>
                                        <button className="btn btn-link text-theme-1">Join Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="row gx-0">
                                <div className="col-12 col-md-6">
                                    <div className="h-100 w-100 miheight-200 coverimg">
                                        <img src={asset("../../assets/img/adminuiux/image-1.jpg")} className="mw-100" alt="" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="card-body">
                                        <p className="mb-3">
                                            <span className="badge badge-lg badge-light text-bg-theme-1 theme-green">Course</span>
                                        </p>
                                        <h6>Communicate with right spirit and with the right people to make your space.</h6>
                                        <p className="text-secondary small mb-3">When you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                        <div className="row gx-3 mb-3">
                                            <div className="col-auto align-self-center">
                                                <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                                    <img src={asset("../../assets/img/adminuiux/user-4.jpg")} alt="" />
                                                </figure>
                                            </div>
                                            <div className="col align-self-center">
                                                <h6 className="mb-0">David Warner</h6>
                                                <p className="small text-secondary">London, UK</p>
                                            </div>
                                        </div>
                                        <button className="btn btn-link text-theme-1">Join Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* email communication */}
                <div className="row gx-3 gx-lg-4 justify-content-center">
                    <div className="col-12 col-md-6 col-xl-4 text-md-end mb-3 mb-lg-4">
                        <h5>Technical problem</h5>
                        <p className="text-mute">If you have any type of technical challenges and would like to get help from us please drop an email at <a href="mailto:info@adminuiux.coms">tech@adminuiux.coms</a>
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 border-left-dashed mb-3 mb-lg-4">
                        <h5>General Support</h5>
                        <p className="text-mute">If you have any type of challenges regarding products and would like to get help from us please drop an email at <a href="mailto:info@adminuiux.coms">sales@adminuiux.coms</a>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyHelpCenter;
